import React, { FC } from 'react';
import { FormCheckboxGroup } from '@saif/form-checkbox-input';
import { permissionNames, permissionLabels } from './constants';

interface PermissionCheckboxGroupProps {
  required?: boolean;
  getValue: (section: string, key: string) => string;
}

const PermissionCheckboxGroup: FC<PermissionCheckboxGroupProps> = ({
  required = true,
  getValue,
}) => (
  <FormCheckboxGroup
    name="permissions"
    label={getValue('RequestAccess', 'PermissionsLabel')}
    hintText={getValue('RequestAccess', 'PermissionsHintText')}
    required={required}
    requiredMessage={getValue('RequestAccess', 'ValPermissions')}
    options={[
      {
        value: permissionNames.CLAIMS,
        label: getValue(permissionLabels.CLAIMS.section, permissionLabels.CLAIMS.key),
      },
      {
        value: permissionNames.PAYROLL,
        label: getValue(permissionLabels.PAYROLL.section, permissionLabels.PAYROLL.key),
      },
      {
        value: permissionNames.CERTS,
        label: getValue(permissionLabels.CERTS.section, permissionLabels.CERTS.key),
      },
    ]}
  />
);

export default PermissionCheckboxGroup;
